import get from 'lodash/get';

const responseMessages: any = {
  ontologyMaster: {
    200: 'Data fetched successfully!',
    201: 'Ontology created successfully!',
    202: 'Ontology updated successfully!',
    204: 'Ontology deleted successfully!',
    409: 'Not able to create/update, Ontology is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Application is down for maintenance, we are working on it.',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
  },
  platformServicesMaster: {
    200: 'Data fetched successfully!',
    201: 'Platform Service created successfully!',
    202: 'Platform Service updated successfully!',
    204: 'Platform Service deleted successfully!',
    409: 'Not able to create/update, Platform Service is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Platform Service not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
  },
  componentMaster: {
    200: 'Data fetched successfully!',
    201: 'Component created successfully!',
    202: 'Component updated successfully!',
    204: 'Component deleted successfully!',
    409: 'Not able to create/update, Component name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Componenet not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
  },
  factoryManagement: {
    200: 'Data fetched successfully!',
    201: 'Factory created successfully!',
    202: 'Factory updated successfully!',
    204: 'Factory deleted successfully!',
    409: 'Not able to create/update, Factory name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Factory not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  machineryManagement: {
    200: 'Data fetched successfully!',
    201: 'Machine created successfully!',
    202: 'Machine updated successfully!',
    204: 'Machine deleted successfully!',
    409: '"MACHINE NAME" already exists, Please specify alternative "MACHINE NAME".',
    400: 'Something went wrong, please try again',
    404: 'Machine not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
  },
  partManagement: {
    200: 'Data fetched successfully!',
    201: 'Part created successfully!',
    202: 'Part updated successfully!',
    204: 'Part deleted successfully!',
    409: '"PART NAME" already exists, Please specify alternative "PART NAME".',
    400: 'Something went wrong, please try again',
    404: 'Part not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  gatewayMaster: {
    200: 'Data fetched successfully!',
    201: 'Gateway created successfully!',
    202: 'Gateway updated successfully!',
    204: 'Gateway deleted successfully!',
    409: 'Not able to create/update, Gateway name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Gateway not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  buildUseCase: {
    200: 'Data fetched successfully!',
    201: 'Use Case created successfully!',
    202: 'Use Case updated successfully!',
    204: 'Use Case deleted successfully!',
    409: 'Not able to create/update, Use Case is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Use Case not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
  },
  userManagement: {
    200: 'Data fetched successfully!',
    201: 'User created successfully!',
    202: 'User updated successfully!',
    204: 'User deleted successfully!',
    409: 'Not able to create/update, User is already exists!',
    400: 'Something went wrong, please try again',
    404: 'User not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    422: 'Given information is invalid',
    206: '',
  },
  userRoleManagement: {
    200: 'Data fetched successfully!',
    201: 'Role created successfully!',
    202: 'Role Updated succeessfully!',
    204: 'Role deleted successfully!',
    409: 'Not able to create, Role is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Role not found!',
    406: 'Requested data is not available to delete/add',
    403: "You don't have permission to access this!",
    422: 'Given information is invalid',
    206: '',
  },
  profile: {
    200: 'Data fetched successfully!',
    202: 'Password Updated succeessfully!',
    400: 'Something went wrong, please try again',
    403: "You don't have permission to access this!",
    422: 'Given information is invalid',
  },
  settings: {
    200: 'Data fetched successfully!',
    201: 'Data created successfully!',
    202: 'Data updated successfully!',
    204: 'Data deleted successfully!',
    409: 'Data already exists.',
    400: 'Something went wrong, please try again',
    404: 'Data not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
  },
  conDashboard: {
    200: 'Data fetched successfully!',
    202: 'Password Updated succeessfully!',
    400: 'Something went wrong, please try again',
    403: "You don't have permission to access this!",
    422: 'Given information is invalid',
  },
  digitalTwin: {
    200: 'Data fetched successfully!',
    201: 'Digital twin created successfully!',
    202: 'Digital twin updated successfully!',
    204: 'Digital twin deleted successfully!',
    409: 'Not able to create/update, Digital twin name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Digital twin not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  secretsManager: {
    200: 'Data fetched successfully!',
    201: 'Secrets created successfully!',
    202: 'Secrets updated successfully!',
    204: 'Secrets deleted successfully!',
    409: 'Not able to create/update, Secrets name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Secrets not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  maintenance: {
    200: 'Data fetched successfully!',
    201: 'Maintenance Plan created successfully!',
    202: 'Maintenance Plan updated successfully!',
    204: 'Maintenance Plan deleted successfully!',
    409: 'Maintenance Plan name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Maintenance Plan not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  secretsManagerTemplate: {
    200: 'Data fetched successfully!',
    201: 'Secret Template created successfully!',
    202: 'Secret Template updated successfully!',
    204: 'Secret Template deleted successfully!',
    409: 'Not able to create/update, Secret Template name is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Secret Template not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  checklist: {
    200: 'Data fetched successfully!',
    202: 'Maintenance Activity updated successfully!',
    204: 'Maintenance Activity deleted successfully!',
    409: 'Maintenance Activity name is already exists or in use with any maintenance!',
    400: 'Something went wrong, please try again',
    404: 'Maintenance Activity not found!',
    406: 'Requested data is not available to delete/update/add!',
    403: "You don't have permission to access this!",
    206: '',
  },
  useCaseBuilder: {
    200: 'Data fetched successfully!',
    201: 'Use Case created successfully!',
    202: 'Use Case updated successfully!',
    204: 'Use Case deleted successfully!',
    409: 'Not able to create/update, Use Case is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Use Case not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
    422: 'Given information is invalid!',
  },
  customJsonTemplate: {
    200: 'Data fetched successfully!',
    201: 'Template created successfully!',
    202: 'Template updated successfully!',
    204: 'Template deleted successfully!',
    409: 'Not able to create/update, Template is already exists!',
    400: 'Something went wrong, please try again',
    404: 'Template not found!',
    406: 'Requested data is not available to delete/update/add',
    403: "You don't have permission to access this!",
    206: '',
    422: 'Given information is invalid!',
  },
  101: 'No response from backend.',
};

export const getStatusMessage = (pageName: string, statusCode: number) => {
  if (statusCode === 401) {
    window.location.href = window.location.origin ?? '/';
  }
  return get(responseMessages, `${pageName}.${statusCode}`, responseMessages[101]);
};
